import React from 'react';
import styled from 'styled-components';


const StyledProgressBar= styled.ul`
		position: absolute;
		top: 0;
		width: 6px;
		height: 100%;
		z-index: 3;
		left: calc(50% - 6px);
		margin: 0;
		padding: 0;

		li {
				background-color: ${props => props.color};
				width: 6px;
				margin: 0;
				padding: 0;
				list-style: none;
				height: ${props => props.indicatorHeight}%;
				border-bottom: 1px solid #fff;
				cursor: pointer;
		}

	  @media (max-width: 576px) {
	    display: none;
	  }

	}
`;


const ProgressBar = (props) => {

	const { currentStep, slide } = props;

		const clickHandler = evt => {
			const step = +evt.target.id.replace('indicator','');
			slide('up', step);
		}

		const stepsIndicators = [];
		for (var i = 0; i < currentStep; i++) {
			stepsIndicators.push(<li key={"stepIndicator"+i} id={"indicator"+(i+1)} onClick={clickHandler}></li>)
		}

	  return (
	  	<StyledProgressBar color={'#e5b2cf'} indicatorHeight={100/(props.numberOfSteps)}>
	  		{stepsIndicators}
  		</StyledProgressBar>
	  )

}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.js